<main class="container-fluid">
  <div  *ngIf="informacionEstablecimiento2"  >

    <section class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
      <header class="row d-flex align-items-center w-100 p-4">
        <div class="col-sm-12 col-md-4 d-flex flex-row">
          <img src="/assets/icons/info-establecimiento.png" class="ml-5 d-inline-block rounded-circle" alt=""
            height="38">
          <label class="ml-3 small text-muted mb-0">Nombre<br>
            <strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento2.razon_social}}</strong>
          </label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Número RNT<br>
            <strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento2.codigo_rnt}}</strong>
            </label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Número de radicación<br>
            <strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento2.numero_radicacion}}</strong>
          </label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Tipo de solicitud<br>
            <strong  class="h6 text-dark font-weight-bold">{{informacionEstablecimiento2.tipo_solicitud}}</strong>
          </label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Estado solicitud<br>
            <strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento2.estado_solicitud}}</strong>
          </label>
          <!-- <img src="../../../../../../../assets/icons/question.png" alt="" height="25" class="pointer float-right"> -->
        </div>

      </header>
    </section>
  </div>

  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">

    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">Informacion del prestador</label>
      </header>
      <form [formGroup]="formularioDatos" (ngSubmit)="ClickBuscar()">
        <div class="form-group">
          <label class="small text-secondary" for="codigo">{{ labelTextA }}</label>
          <div class="row">
              <select class="col-6 custom-select reversion-select"  formControlName="tipo_filtro" (change)="setSelectedFilter2()">
                <option [ngValue]="1">RNT</option>
                <option [ngValue]="2">Radicación</option>
               </select>
              <input id="codigo"  formControlName="codigo" type="text" class="col-6 form-control form-control-sm reversion-input">
          </div>
          <div class="row mt-2" *ngIf=" aux=='radicado' ">
              <label class="small text-secondary mb-0">Cámara de Comercio</label>
              <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                <option class="" value="null" selected="true">
                  Seleccione
                </option>
                <option class="" *ngFor="let option of camarasLista; let i = index"
                  value="{{option?.codigo_camara}}" [selected]="false">
                  {{option?.desc_camara}}
                </option>
              </select>
        </div>
        <span class="text-danger" *ngIf="formularioDatos.get('codigo_camara')?.hasError('required') && (formularioDatos.get('codigo_camara').touched || formularioDatos.get('codigo_camara').dirty)">
          * El campo es requerido
         </span>
        </div>
        <div class="form-row mt-5">
          <button class="btn btn-primary m-auto "  [disabled]="!formularioDatos.valid"  type="submit">Buscar</button>
        </div>
      </form>
    </section>

    <section class="col-9 p-4 mt-5 mb-5" *ngIf="informacionEstablecimiento2; else no_data">
      <div class="d-flex justify-content-between">
       <!-- formulario nuevo -->

       <section  class="row mb-4 pl-2"  >

        <!-- <div class="col-lg-12" *ngIf="actSincronizar;"  >
          <img src="../../../../../../../../assets/icons/refresh_perfil.png" class="pointer float-right "  height="38"  (click)=" SincronizarPrestador()"  />
        </div> -->

           <!-- seccion Informacion prestador-->
           <section class="col-12 mb-4 mt-4 border-bottom">
            <footer class="row">
              <h2 class="col-9 h5 font-weight-bold mb-2">Datos del prestador</h2>
              <p class="col-3 small">
                Última actualización:
                <strong>{{
                  informacionEstablecimiento2.fecha_ultima_actualizacion
                    | date: "d/MMM/yyyy, h:mm a"
                }}</strong>
              </p>

                <div class="col-sm-12 col-md-3">
                  <label class="small mb-0">Representante legal</label>
                  <p>
                    <strong>{{
                      informacionEstablecimiento2.nombre_representante_legal
                    }}</strong>
                  </p>
                </div>

                <div class="col-sm-12 col-md-3">
                  <label class="small mb-0"># identificación  representante legal</label>
                  <p>
                    <strong>{{
                      informacionEstablecimiento2.numero_identificacion_representante_legal
                    }}</strong>
                  </p>
                </div>

              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Patrimonio neto</label>
                <p>
                  <strong>{{
                    informacionEstablecimiento2.patrimonio_neto | currency: "COP"
                  }}</strong>
                </p>
              </div>

               <div class="col-sm-12 col-md-3">
                 <label class="small mb-0">Número de empleados : {{ informacionEstablecimiento2.numero_empleados }} </label>
               </div>
            </footer>
          </section>

          <!--seccion  de categoria(Establecimiento / inmueble)-->

          <section class="col-12 mb-4 mt-1 border-bottom">
            <footer class="row">
              <div class="col-lg-12">
                <img  *ngIf="actEdit;" src="../../../../../../../../assets/icons/edit.png" class="pointer float-right "  height="38"   (click)="UpdateSubCategoria()"   />
              </div>
              <!-- Establecimiento -->
              <ng-container *ngIf="informacionEstablecimiento2.tipo_rnt_id === 1" >
                <h2 class="col-12 h5 font-weight-bold mb-2">
                  Datos del establecimiento
                </h2>
                <div class="col-sm-12 col-md-3">
                  <label class="small mb-0">Nombre</label>
                  <p>
                    <strong>{{ informacionEstablecimiento2.razon_social }}</strong>
                  </p>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="informacionEstablecimiento2.matricula">
                  <label class="small mb-0">Matrícula mercantíl</label>
                  <p>
                    <strong>{{ informacionEstablecimiento2.matricula }}</strong>
                  </p>
                </div>
                <div class="col-sm-12 col-md-3">
                  <label class="small mb-0">Último año renovado</label>
                  <p>
                    <strong>{{
                      informacionEstablecimiento2.ultimo_anio_renovado
                    }}</strong>
                  </p>
                </div>
              </ng-container>
           <!-- Inmueble -->
              <ng-container
                *ngIf="informacionEstablecimiento2.tipo_rnt_id === 3"
               >
                <h2 class="col-12 h5 font-weight-bold mb-2">Datos del inmueble</h2>
              </ng-container>
              <!-- Guia -->
              <ng-container *ngIf="informacionEstablecimiento2.tipo_rnt_id === 2">
                <h2 class="col-12 h5 font-weight-bold mb-2">Datos del guía</h2>
                <div class="col-sm-12 col-md-3">
                  <label class="small mb-0">Nombre de guia</label>
                  <p>
                    <strong>{{ informacionEstablecimiento2.nombre_gerente }}</strong>
                  </p>
                </div>
              </ng-container>
              <!-- Datos generales -->
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Codigo RNT : {{ informacionEstablecimiento2.codigo_rnt }} </label>
              </div>
              <!-- <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Codigo Solicitud : {{ informacionEstablecimiento2.solicitud_id }} </label>
              </div> -->
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Último año renovado RNT</label>
                <p>
                  <strong>{{
                    informacionEstablecimiento2.ultimo_anio_renovado_rnt
                  }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Dirección</label>
                <p>
                  <strong>{{ informacionEstablecimiento2.direccion_comercial }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Departamento</label>
                <p>
                  <strong>{{ informacionEstablecimiento2.departamento }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Municipio</label>
                <p>
                  <strong>{{ informacionEstablecimiento2.municipio }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Cámara de comercio</label>
                <p>
                  <strong>{{
                    informacionEstablecimiento2.desc_camara_largo
                  }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Categoría</label>
                <p>
                  <strong>{{ informacionEstablecimiento2.categoria }}</strong>
                </p>
              </div>
               <div class="col-sm-12 col-md-3">
               <label class="small mb-0">Sub categoría Actual</label>
                  <p>
                    <strong>{{ informacionEstablecimiento2.subcategoria }}</strong>
                  </p>
              </div>
              <!-- cambio subcategoria -->
              <div class="col-sm-12 col-offset-md-1 col-md-7 form-group"   *ngIf="actEdit"  >
                <label for="sub_categoria_id" class="small text-secondary required">Subcategoría</label>
                <select id="sub_categoria_id" class="form-control" [disabled]="activeFormSel" (change)="capturarSelect()"
                [(ngModel)]="selectedOption">
                  <option class="" [ngValue]="null" selected="true">
                    Seleccione
                  </option>
                  <ng-container *ngFor="let item of subCategorias">
                    <option [ngValue]="item.sub_categoria_id">
                      {{ item.descripcion }}
                    </option>
                  </ng-container>
                </select>
              </div>

              <div class="col-lg-12" *ngIf="actEdit"   >
                <input type="button" id="GuardarCambios" value="Guardar Cambios" class="btn btn-success float-right"  [disabled]="activeFormSel"   (click)="UpdateFormulario()" >
              </div>
                <br />
              </footer>
          </section>

           <!--seccion de informacion adicional-->
           <section class="col-12 row mb-4">
            <h2 class="col-12 h5 font-weight-bold mb-2">
              Datos adicionales del prestador
            </h2>
            <div class="col-sm-12 col-md-4">
              <header class="mb-3">
                <h2 class="h6 font-weight-bold mb-4">Contacto</h2>
              </header>
              <footer class="row">
                <p class="col-5 small">Teléfono Fijo:</p>
                <p class="col-7 font-weight-bold small">
                  {{ informacionEstablecimiento2.numero_telefonico }}
                </p>
                <p class="col-5 small">Celular:</p>
                <p class="col-7 font-weight-bold small">
                  {{ informacionEstablecimiento2.numero_celular }}
                </p>
                <p class="col-5 small">Número fax:</p>
                <p class="col-7 font-weight-bold small">
                  {{ informacionEstablecimiento2.fax }}
                </p>
                <p class="col-5 small">Correo eletrónico:</p>
                <p class="col-7 font-weight-bold small text-large">
                  {{ informacionEstablecimiento2.correo_electronico }}
                </p>
              </footer>
            </div>
            <div class="col-sm-12 col-md-4">
              <header class="mb-3">
                <h2 class="h6 font-weight-bold mb-4">Notificaciones</h2>
              </header>
              <footer class="row">
                <p class="col-6 small">Departamento notificaciones:</p>
                <p class="col-6 font-weight-bold small">
                  {{ informacionEstablecimiento2.departamento_notificacion }}
                </p>
                <p class="col-6 small">Municipio notificaciones:</p>
                <p class="col-6 font-weight-bold small">
                  {{ informacionEstablecimiento2.municipio_notificacion }}
                </p>
                <p class="col-6 small">Teléfono notificaciones:</p>
                <p class="col-6 font-weight-bold small">
                  {{ informacionEstablecimiento2.numero_telefonico_notificacion }}
                </p>
                <p class="col-6 small">Dirección notificaciones:</p>
                <p class="col-6 font-weight-bold small">
                  {{ informacionEstablecimiento2.direccion_notificacion }}
                </p>
              </footer>
            </div>
          </section>
              <!-- <ng-container *ngIf="!actEdit">
                <section  class="col-12 mb-4 mt-4 border-top">
                  <footer class="row">
                    <div class="col-sm-12 col-md-10">
                      <div class="small mb-0">
                        <h3 class="h6 font-weight-bold mb-4">Tenga en cuenta que...</h3>
                        <p>Solo se puede Actualizar aquellos rnt que se encuentren en los siguentes estados:</p>
                        <p>1.) Inscripcion no aprobada.</p>
                        <p>2.) Renovaion en tramite.</p>
                        <p>3.) Renovaion no aprobada.</p>
                        <p> * Si tiene alguna duda acerca del estado del rnt, consulte el historial de solicitudes.</p>
                      </div>
                    </div>
                  </footer>
                  </section>
              </ng-container> -->


         </section>
       <!-- end formulario -->
      </div>
    </section>

    <ng-template #no_data>
      <section class="col-9 p-4 mt-5 mb-5">
        <header class="col-12">
          <figure class="figure w-100 text-center">
            <img class="img-fluid mb-4" src="../../../../../../../assets/images/sin_establecimiento.png" />
            <figcaption>
              <label class="h3">No hay información</label>
            </figcaption>
          </figure>
        </header>
      </section>
    </ng-template>

  </article>
</main>


